import React from "react";
import {IntlShape} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";

import {isColorOnlyGroup} from "../../aiColorOnlyGroupsConstants";
import {getFeatureGroupName} from "../../../../misc/helpers";
import {AiAccordionGroupObject} from "../../aiAccordeonGroups";

type Props = {
  groupObject: AiAccordionGroupObject;
  intl: IntlShape;
  fabricatorData: any;
  onToggle: (groupObject: AiAccordionGroupObject) => (e: React.MouseEvent) => void;
  onColorOnlyChange: (groupObject: AiAccordionGroupObject) => (e: React.ChangeEvent<HTMLInputElement>) => void;
};

// Single group row: the on/off Switch for one AI feature group (e.g. "Countertop"), plus its
// "Color Only" checkbox when the fabricator has aiSettings.colorOnly on and this group supports
// it. Pulled out of LookAIPopupFeatureGroups so it can be reused as-is both in the flat list
// (no accordion, <=1 section) and inside LookAIPopupFeatureGroupAccordion.
export default function LookAIPopupFeatureGroupRow({
  groupObject,
  intl,
  fabricatorData,
  onToggle,
  onColorOnlyChange,
}: Props) {
  return (
    <li className="u-mb-025 flex flex--column !items-start u-w-full">
      <div className="flex justify-between gap-2 items-center u-w-full">
        <FormControlLabel
          style={{color: "#66778D"}}
          label={getFeatureGroupName(groupObject.featureGroup, intl, fabricatorData, true)}
          className="u-m-0 flex--1 [&>span]:!leading-none"
          control={
            <Switch
              checked={!!groupObject.enabled}
              className="gm-ios-checkbox"
              disableRipple
              onClick={onToggle(groupObject)}
              // keep onChange as a no-op (or omit it) so click is the single source of truth
              onChange={() => {}}
              color="primary"
            />
          }
        />
      </div>
      {fabricatorData.aiSettings?.colorOnly
      && isColorOnlyGroup(groupObject.featureGroup?.partId || groupObject.partId) ? (
        <div className="flex items-center" style={{paddingLeft: "44px"}}>
          <FormControlLabel
            style={{color: "#66778D"}}
            label="Color Only"
            className="u-m-0 h-6 bold color-primary text-left [&>span]:text-[14px] [&>.MuiButtonBase-root]:p-1"
            control={
              <Checkbox
                size="small"
                checked={!!groupObject.colorOnly}
                onChange={onColorOnlyChange(groupObject)}
                color="primary"
              />
            }
          />
        </div>
      ) : null}
    </li>
  );
}
